import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  trainingButtonCompleted: {
    id: 'studio.95stPq',
    defaultMessage: 'Completed',
  },
  trainingButtonNotCompleted: {
    id: 'studio.v8UPo8',
    defaultMessage: 'Click to complete',
  },
  completeFailed: {
    id: 'studio.cs4SFN',
    defaultMessage: 'Something went wrong trying to complete this training',
  },
  backToTree: {
    id: 'studio./oMiH4',
    defaultMessage: 'Back to tree',
  },
  to: {
    id: 'studio.9j3hXO',
    defaultMessage: 'To',
  },
});
